import React from 'react';
import PropTypes from 'prop-types';
import {AccordionItem} from '@/components/molecules';
import ActivityImageUploadSection from './ActivityImageUploadSection';

const ImageUploadAccordionItem = ({
  index,
  label,
  subTitle,
  sectionConfig,
  gameData,
  imageFields,
  imageHandlers,
  setShowGuidelines
}) => (
  <AccordionItem
    isDark
    expanded
    index={index}
    label={label}
    onUpdate={() => {}}
    subTitle={subTitle}
    content={
      <div className='w-full'>
        <ActivityImageUploadSection
          {...sectionConfig}
          gameData={gameData}
          imageFields={imageFields}
          imageHandlers={imageHandlers}
          setShowGuidelines={setShowGuidelines}
          showSectionHeader={false}
        />
      </div>
    }
  />
);

ImageUploadAccordionItem.propTypes = {
  index: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  sectionConfig: PropTypes.object.isRequired,
  gameData: PropTypes.object.isRequired,
  imageFields: PropTypes.array.isRequired,
  imageHandlers: PropTypes.object.isRequired,
  setShowGuidelines: PropTypes.func.isRequired
};

ImageUploadAccordionItem.defaultProps = {
  subTitle: ''
};

export default React.memo(ImageUploadAccordionItem);
